import { render, staticRenderFns } from "./PlayerLiveDropdown.vue?vue&type=template&id=5f479aa7"
import script from "./PlayerLiveDropdown.js?vue&type=script&lang=js&external"
export * from "./PlayerLiveDropdown.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports